import utils from "@/common/Utils";
import AuthService from "@/services/auth.service";

class NativeBridge {
  constructor() {
    this.registerCallback();
  }

  public init(){
    utils.log('NativeBridge init')
  }

  private registerCallback() {
    window.insertPushTokenResult = this.insertPushTokenResult;
  }

  private insertPushTokenResult(message: any) {
    let params = {
      deviceId: message.deviceId,
      memberIdx: message.memberIdx,
      pushToken: message.pushToken,
      deviceType: message.deviceType,
      deviceName: message.deviceName,
      osVersion: message.osVersion,
    }
    AuthService.insertPushToken(params).then(
      (response) => {
        if(response.success)
          utils.log('token insert : '+params.memberIdx)
        else
          utils.log('token error : '+response.message)
      },
      (error) => {
        utils.log((error.response && error.response.data && error.response.data.message) || error.message || error.toString())
        if (error.status == 403)
          utils.movePage('/login')
      }
    )
  }
}

// 싱글톤 패턴으로 인스턴스 생성
export default new NativeBridge()
